import { InputProps } from "antd";
import { omit } from "lodash";
import MaskedInput from "react-text-mask";
import { AMERICANEXPRESS, CARDICON, OTHERCARDS } from "./Contants";
import styled from "styled-components";
import React from 'react';

const TextMask = MaskedInput as unknown as React.ComponentType<{
  mask: (string | RegExp)[];
  guide: boolean;
  value?: string;
  className?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  placeholder?: string;
}>;

interface CardRegexPatterns {
  MASTERCARD: RegExp;
  VISA: RegExp;
  AMERICAN_EXPRESS: RegExp;
  DISCOVER: RegExp;
  DINERS_CLUB: RegExp;
  JCB: RegExp;
  [key: string]: RegExp;
}

function findDebitCardType(cardNumber: string): string {
  const regexPattern: CardRegexPatterns = {
    MASTERCARD: /^5[1-5][0-9]{1,}|^2[2-7][0-9]{1,}$/,
    VISA: /^4[0-9]{2,}$/,
    AMERICAN_EXPRESS: /^3[47][0-9]{5,}$/,
    DISCOVER: /^6(?:011|5[0-9]{2})[0-9]{3,}$/,
    DINERS_CLUB: /^3(?:0[0-5]|[68][0-9])[0-9]{4,}$/,
    JCB: /^(?:2131|1800|35[0-9]{3})[0-9]{3,}$/,
  };
  for (const card in regexPattern) {
    if (cardNumber.replace(/[^\d]/g, "").match(regexPattern[card])) return card;
  }
  return "";
}

const StyledCardComponent = styled.div`
  position: relative;
  .cardIcon {
    position: absolute;
    right: 0;
    top: 10px;
    margin-right: 10px;
  }
  .cardIcon svg {
    width: 30px;
  }
`;

interface BankCardProps extends Omit<InputProps, 'size' | 'prefix'> {
  value?: string;
}

export const BankCard: React.FC<BankCardProps> = (props) => {
  const cardPrefix = props.value ? 
    (props.value as string).slice(0, 2) : 
    '';

  const {
    value,
    onChange,
    onBlur,
    onFocus,
    disabled,
    placeholder,
  } = props;

  const inputProps = {
    mask: ["37", "34"].includes(cardPrefix) ? AMERICANEXPRESS : OTHERCARDS,
    className: "ant-input ant-input-lg",
    guide: false,
    value,
    onChange,
    onBlur,
    onFocus,
    disabled,
    placeholder,
  };

  return (
    <StyledCardComponent>
      <TextMask
        {...inputProps}
      />
      <span className="cardIcon">
        {props.value && CARDICON[findDebitCardType(props.value as string)]}
      </span>
    </StyledCardComponent>
  );
};

export default BankCard;